// extracted by mini-css-extract-plugin
module.exports = {"blur":"styles_blur__2VXwg","colors":"styles_colors__3efhk"};